import checkAuthenticated from "@/router/middlewares/checkAuthenticated";
import checkLinkedEmployee from "@/router/middlewares/checkLinkedEmployee";
import DECORATION_TYPES from '@/router/enums/DECORATION_TYPES';

export default [
    {
        path: '/monthOfEmployees',
        name: 'MonthOverView',
        component: () => import(/* webpackChunkName: "monthofemployees" */ '@/modules/month/overview/components/MonthOverView'),
        meta: { moduleId: 'monthOfEmployees' },
        props: true,
        beforeEnter: checkLinkedEmployee
    },
    {
        path: '/reopenMonth',
        name: 'ReopenMonthView',
        component: () => import(/* webpackChunkName: "reopenMonth" */ '@/modules/month/reopen/ReopenMonthView'),
        meta: { moduleId: 'reopenMonth' },
        beforeEnter: checkAuthenticated
    },
    {
        path: '/calendar',
        name: 'CalendarView',
        component: () => import(/* webpackChunkName: "calendarView" */ '@/modules/month/calendar/CalendarView'),
        meta: { moduleId: 'monthCalendar' },
        beforeEnter: checkAuthenticated
    },
    {
        path: '/monthlyVerification',
        name: 'MonthlyVerificationView',
        component: () => import(/* webpackChunkName: "monthlyVerificationView" */ '@/modules/month/overview/components/MonthlyVerificationView'),
        meta: { moduleId: 'monthlyVerificationView' },
        props: true,
    },
    {
        path: '/absence',
        name: 'MonthlyAbsenceView',
        component: () => import(/* webpackChunkName: "MonthAbsenceView" */ '@/modules/month/overview/components/MonthlyAbsenceView'),
        meta: { moduleId: 'monthlyAbsence' },
        props: true,
    },
    {
        path: '/monthlyAbsenceConfiguration',
        name: 'MonthlyAbsenceConfigurationView',
        component: () => import(/* webpackChunkName: "MonthlyAbsenceConfigurationView" */ '@/modules/month/overview/components/MonthlyAbsenceConfiguration'),
        meta: { moduleId: 'monthlyAbsenceConfiguration' },
        props: true,
    },
    {
        path: '/balancechange',
        name: 'monthBalanceOverview',
        component: () => import(/* webpackChunkName: "monthBalanceOverview" */ '@/modules/month/overview/components/MonthBalanceOverView'),
        meta: {
            moduleId: 'monthBalanceOverview',
            decorations: [DECORATION_TYPES.GENERATE_TABLE_CACHE_ID],
        },
        props: true,
        beforeEnter: checkAuthenticated
    },
    {
        path: '/balancechange/:id',
        name: 'BalanceChangeForm',
        component: () =>
            import(
            /* webpackChunkName: "BalanceChangeForm" */ '@/modules/month/overview/components/BalanceChangeForm'
            ),
        meta: {
            moduleId: 'monthBalanceOverview',
        },
        props: true,
        beforeEnter: checkAuthenticated
    },
    {
        path: '/monthConfirmation',
        name: 'monthConfirmationOverView',
        component: () => import(/* webpackChunkName: "monthConfirmation" */ '@/modules/month/confirmation/components/MonthConfirmation'),
        meta: {
            moduleId: 'monthConfirmation'
        },
    },
    {
        path: '/import',
        name: 'WorkingHoursImportView',
        component: () => import(/* webpackChunkName: "working-hours-import" */ '@/modules/timetracking/components/workingHours/WorkingHoursImportView'),
        meta: {
            moduleId: 'workinghoursimport',
        },
        props: true,
        beforeEnter: checkAuthenticated
    },
]
